export const getPercent = (count: number, total: number) =>
  // 不使用 Math.round 是為了避免 99.9 這類數字被四捨五入成 100
  Math.floor((count / total) * 1000) / 10
